const fallback = process.env.NEXT_PUBLIC_ADSENSE_SLOT_NATIVE ?? "";

export const ADSENSE_SLOTS = {
  grid: process.env.NEXT_PUBLIC_ADSENSE_SLOT_GRID || fallback,
  category: process.env.NEXT_PUBLIC_ADSENSE_SLOT_CATEGORY || fallback,
  hashtag: process.env.NEXT_PUBLIC_ADSENSE_SLOT_HASHTAG || fallback,
  pack: process.env.NEXT_PUBLIC_ADSENSE_SLOT_PACK || fallback,
  // Multiplex (matched-content) intentionally has no fallback — the native
  // fluid layout-key slot won't render correctly as autorelaxed. The wrapper
  // returns null when this is empty, so the unit simply doesn't show until
  // a real multiplex slot is created in the AdSense console.
  multiplex: process.env.NEXT_PUBLIC_ADSENSE_SLOT_MULTIPLEX || "",
} as const;

export const ADSENSE_NATIVE_LAYOUT_KEY = "-6s+ed+2g-1n-4q";
